var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { ZIndex } from "@skbkontur/react-ui/internal/ZIndex";
import styles from "./Highlight.module.css";
export function Highlight(props) {
    var pos = props.pos, highlight = props.highlight, color = props.color;
    var highlightRoot = React.cloneElement(highlight, __assign(__assign({}, highlight.props), { style: __assign(__assign({}, highlight.props.style), { position: "absolute", top: 0, left: 0, bottom: 0, right: 0 }) }));
    var width = pos.right - pos.left;
    var height = pos.bottom - pos.top;
    var borderTopWidth = pos.top + document.documentElement.scrollTop;
    var borderLeftWidth = pos.left + document.documentElement.scrollLeft;
    var computedStyles = {
        borderColor: color,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderRightWidth: document.documentElement.offsetWidth - (borderLeftWidth + width),
        borderBottomWidth: document.documentElement.offsetHeight - (borderTopWidth + height),
        width: width,
        height: height,
    };
    return (React.createElement(ZIndex, { delta: 100, className: styles.wrapper, style: computedStyles }, highlightRoot));
}
